import { render, staticRenderFns } from "./trade-radio-box.vue?vue&type=template&id=7cf8a86a&scoped=true&"
import script from "./trade-radio-box.vue?vue&type=script&lang=js&"
export * from "./trade-radio-box.vue?vue&type=script&lang=js&"
import style0 from "./trade-radio-box.vue?vue&type=style&index=0&id=7cf8a86a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf8a86a",
  null
  
)

component.options.__file = "trade-radio-box.vue"
export default component.exports